import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { Iframe } from '../../../../cms/blocks/iframe.mod';
import { blockInviewHandler } from "../../../utils/inview_utils";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { getClassName } from "../../../../cms/blocks/utils.gen";

export type IframeBlockProps = {
  index: number
  link: string
  // useCookieBar: boolean  TO DO: add again when new cookiebar is added
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type IframeBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export function IframeBlock<CustomBlockData, extra_images>(
  props: IframeBlockProps,
  options?: { style?: IframeBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: onDone => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('iframe', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "container")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "py-5")}>
            <div className={getClassName(options, "content_classname", "")}>
              <div className={getClassName(options, "iframe_classname", "")}>
                  {/* TO DO: add placeholder connected to new cookiebar*/}
                  <Iframe
                    url={props.link}
                    onLoaded={() => { null }}
                  >
                  </Iframe>
              </div>
            </div>
          </div>
        </InView>
      )
    })
}
